import { environment } from '@env/environment';

export const config = Object.freeze(environment);
